export default {
  title: {
    information: 'معلومات',
    confirmation: 'التأكيد مطلوب'
  },
  confirmAction: 'هل أنت متأكد من أنك تريد تنفيذ هذا الإجراء؟',
  reconnect: 'إعادة الاتصال'
}
